import {
  Datagrid,
  DateField,
  EditButton,
  List,
  NumberField,
  TextField,
  useTranslate,
} from 'react-admin';
import { Alert } from '@mui/material';

const PeriodList = () => {
  const translation = useTranslate();
  return (
    <>
      <Alert severity="info" sx={{ marginTop: '1rem' }}>
        {translation('resources.alert.unfinished_list_api')}
      </Alert>
      <List pagination={false}>
        <Datagrid
          isRowSelectable={() => false}
          optimized
          bulkActionButtons={false}
        >
          <NumberField
            source="id"
            options={{
              useGrouping: false,
            }}
          />
          <TextField source="name" />
          <DateField source="start_time" />
          <DateField source="free_from" />
          <DateField source="valid_until" />
          <DateField source="deleted_after" />
          <EditButton />
        </Datagrid>
      </List>
    </>
  );
};

export default PeriodList;
